import { appointmentsHub } from "./appointmentsHub";
import { cleaningsHub } from "./cleaningsHub";
import { expeditionsHub } from "./expeditionsHub";
import { receptionsHub } from "./receptionsHub";
import { saleOrdersHub } from "./saleOrdersHub";
import { transportersHub } from "./transportersHub";
import { workOrdersHub } from "./workOrdersHub";

export class HubsService {
    public async startHubs() {
        this.startHub(workOrdersHub);
        this.startHub(cleaningsHub);
        this.startHub(appointmentsHub);
        this.startHub(receptionsHub);
        this.startHub(expeditionsHub);
        this.startHub(saleOrdersHub);
        this.startHub(transportersHub);
    }

    public async startHub(hub: signalR.HubConnection): Promise<void> {
        try {
            await hub.start();
        }
        catch (error) {
            if ((error as any).statusCode !== 401 && (error as any).statusCode !== 404) {
                // Retry in 5 seconds
                setTimeout(() => this.startHub(hub), 60000);
            }
        }

        // Try to reconnect on connection closed
        hub.onclose(async () => { await this.startHub(hub); });
    }
}
